<template>
  <a id="form" class="n-link">
    <section
      v-if="variants.v1 === variant"
      class="layout-pt-lg layout-pb-lg tw-overflow-hidden"
      :style="`--button-bg-color: var(--c-${vars.buttonColor || 'secondary'}); background-color: var(--c-${vars.backgroundColor})`"
    >
      <BlockSymbol
        v-if="company.company_key === 'copeandco'"
        :position-text="String(vars?.blockPositionText || '')"
        :block-color="String(vars?.blockColor || '')"
        :block-opacity="Number(vars?.blockOpacityNumber || 1)"
        block-symbol="&"
      />
      <div class="container tw-z-10">
        <div class="row justify-center">
          <div v-html="vars.titleHtml" class="text-center col-lg-10" />
        </div>

        <div class="row justify-center pt-60 md:pt-30">
          <div class="col-xl-6 col-lg-8 col-md-10 form-container !tw-text-white">
            <library-form
              v-if="form"
              :form="form"
              version="v2"
              :component="component"
              :is-form-name-visible="vars.isFormNameVisibleBool"
            ></library-form>
          </div>
        </div>
      </div>
    </section>
    .
  </a>

  <section
    v-if="variants.v2 === variant"
    class="n-section-primary tw-min-h-[100svh]"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-self-center tw-pt-20 tw-text-center">
      <div v-html="vars.titleHtml" class="tw-mb-10" />
      <div class="tw-flex tw-flex-col tw-bg-white" style="border-radius: var(--rounded)">
        <div class="tw-flex tw-p-6 md:tw-p-10 xl:tw-px-16">
          <library-form
            v-if="form"
            :form="form"
            version="v2"
            :component="component"
            :is-form-name-visible="vars.isFormNameVisibleBool"
          ></library-form>
        </div>
      </div>
    </div>
  </section>
  <section
    v-if="variants.v3 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div
      class="tw-flex tw-w-full tw-flex-col tw-gap-4 tw-p-6 lg:tw-w-full lg:tw-gap-24"
      :class="vars.isReversedBool ? 'lg:tw-flex-row-reverse' : 'lg:tw-flex-row'"
    >
      <div class="tw-w-full lg:tw-hidden">
        <LibraryImage
          :w-ratio="4"
          :h-ratio="7"
          :src="vars.photoImage"
          class="tw-h-auto tw-w-full"
          style="object-fit: cover; border-radius: var(--rounded)"
        />
      </div>

      <div class="tw-w-full lg:tw-hidden">
        <div
          v-html="vars.titleHtml"
          class="tw-mb-6 tw-mt-3 tw-flex tw-items-start tw-justify-start tw-gap-3 tw-text-start md:tw-mb-10"
        ></div>
      </div>

      <div class="tw-hidden tw-w-full lg:tw-block lg:tw-max-w-[400px]">
        <LibraryImage :w-ratio="4" :h-ratio="7" :src="vars.photoImage" style="border-radius: var(--rounded)" />
      </div>

      <div class="tw-flex tw-w-full tw-flex-col">
        <div
          v-html="vars.titleHtml"
          class="tw-mb-6 tw-mr-auto tw-flex tw-hidden tw-items-start tw-justify-start tw-gap-3 tw-text-start md:tw-mb-10 lg:tw-flex"
        ></div>

        <library-form v-if="form" :form="form" version="v1" :component="component"></library-form>
      </div>
    </div>
  </section>

   <section
    v-if="variants.v4 === variant"
    class="n-section-primary tw-min-h-[100svh]"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-self-center tw-pt-20 tw-text-start">
      <div v-html="vars.titleHtml" class="tw-mb-10" />
      <div class="tw-flex tw-flex-col" style="border-radius: var(--rounded)">
        <div class="tw-flex tw-p-6 md:tw-p-10 xl:tw-px-16">
          <library-form
            v-if="form"
            :form="form"
            version="v2"
            :component="component"
            :is-form-name-visible="vars.isFormNameVisibleBool"
          ></library-form>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'ContactForm',

  components: {
    BlockSymbol,
  },

  mixins: [ComponentMixin],

  data() {
    return {
      form: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.contactForm);
  },

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>

<style scoped>
.form-container ::v-deep(button) {
  text-transform: uppercase !important;
  width: 100%;
}

.block {
  font-size: 40em !important;
  font-weight: 900;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: -1;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: -80px !important;
  left: -90px !important;
}

.form-container ::v-deep(button.n-primary) {
  background-color: var(--c-secondary);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 20px;
  font-weight: 600;
  text-transform: uppercase;
  width: 100%;
  transition: background-color 0.3s ease;
}

.form-container ::v-deep(button.n-primary:hover) {
  background-color: var(--c-secondary-dark, #333);
}

.layout-pt-lg ::v-deep(button.n-primary) {
  background-color: var(--button-bg-color);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 20px;
  font-weight: 600;
  text-transform: uppercase;
  width: 100%;
  transition: background-color 0.3s ease;
}

.contactForm select,
.contactForm input:not([type='range']),
.contactForm textarea {
  font-size: 16px;
  line-height: 30px;
  border-bottom: 1px solid white;
  border-left: 1px solid white;
  border-right: 1px solid white;
  border-top: 1px solid white;
  padding-bottom: 10px;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  color: white;
  padding: 15px 10px;
}
</style>
